<i18n>
{
  "ja": {
    "title": "使い方",
    "description": "WareXの使い方ガイドです。登録の仕方や倉庫の探し方、問い合わせ方法、入出荷方法など、使い方をご紹介します。",
    "lead": "WareXのご利用方法を、{newline-sp}実際の画面と合わせてご紹介します。"
  },
  "en": {
    "title": "How to Use"
  }
}
</i18n>

<template>
  <div>
    <header class="my-16 text-center w-7/8 mx-auto">
      <h1 class="block-header">{{ $t("title") }}</h1>
      <p class="ornament-header">{{ $t("title", "en") }}</p>
    </header>

    <div v-if="howToUses.length" class="text-center mb-6 w-7/8 lg:w-auto mx-auto">
      <i18n path="lead" tag="p" class="mb-6 -mt-3 md:mt-0">
        <template #newline-sp><br class="md:hidden"></template>
      </i18n>
      <nav class="mb-6" :class="{ 'opacity-50 pointer-events-none': !canTabChange }">
        <ul class="flex flex-wrap justify-center max-w-800 mx-auto">
          <li v-for="(item, index) in howToUses" :key="index" class="w-48p py-2 md:w-1/4 md:p-3 block">
            <button
              :class="isCurrent(index) ? 'bg-secondary text-white pointer-events-none shadow-btn' : 'bg-gray-200 text-gray-600 hover:shadow-btn'"
              class="rounded px-2 md:p-3 flex justify-center items-center w-full h-12 md:h-16 font-bold transition duration-300"
              @click.prevent="onTabChange(item)">
              {{ item.title }}
            </button>
          </li>
        </ul>
      </nav>
      <div class="flex items-center justify-center mt-6">
        <img class="mx-2" src="~assets/img/index/scrollIcon2.svg" width="20" />
        <img class="mx-2" src="~assets/img/index/scrollIcon2.svg" width="20" />
        <img class="mx-2" src="~assets/img/index/scrollIcon2.svg" width="20" />
      </div>
    </div>

    <div ref="contents" v-if="item" class="bg-gray-100 py-12 md:py-16">
      <h2 class="text-2xl font-semibold text-center mb-8">
        {{ item.title }}
        <span class="w-6 h-0 border-solid border-t-3 border-secondary mx-auto mt-3 block" />
      </h2>
      <list
        v-show="isCurrent(index)"
        v-for="(item, index) in howToUses"
        v-intersect="onInterset"
        :key="index"
        :item="item"
        class="transition duration-1000 opacity-0"
      />
    </div>

    <contact :bg-white="true" />
    <BreadcrumbsFoot :list="breadcrumbs" />
  </div>
</template>

<script>
import list from '@/components/how-to-use/list';
import contact from '@/components/contact';
import BreadcrumbsFoot from "@/components/breadcrumbsFoot";
import Jsonld from '@/components/mixins/jsonld';

export default {
  mixins: [Jsonld],
  components: { list, contact, BreadcrumbsFoot },
  async middleware({ store }) {
    await store.dispatch("cms/howToUses")
  },
  data() {
    return {
      canTabChange: true,
      tabChangeDelayTime: 300,
      breadcrumbs: [
        { name: this.$t('title') }
      ]
    }
  },
  created() {
    if (process.client) {
      this.$store.dispatch('cms/howToUses')
    }
  },
  computed: {
    howToUses() {
      return this.$store.getters['cms/howToUses'] || []
    },
    idx() {
      const { tab } = this.$route.query || {}
      const items = this.howToUses || []
      const index = items.findIndex(e => e.slug === tab)
      return index > -1 ? index : 0
    },
    item() {
      const items = this.howToUses[this.idx] || null
      return items
    },
    global() {
      return this.$store.getters['cms/global']
    }
  },
  methods: {
    isCurrent(index, delay = 0) {
      return this.idx === index
    },
    onTabChange(item) {
      if (item || this.canTabChange) {
        this.canTabChange = false
        this.$router.push({ query: { tab: item.slug } })
        this.$refs.contents && this.$scrollTo(this.$refs.contents)
        setTimeout(() => { this.canTabChange = true }, this.tabChangeDelayTime)
      }
    },
    onInterset(entries) {
      const target = entries.target;
      target.classList && target.classList.toggle
        ? target.classList.toggle("opacity-100", entries.isIntersecting)
        : (target.className += " opacity-100");
    }
  },
  head() {
    const { defaultSeo } = this.global;
    const fullSeo = {
      ...defaultSeo,
      metaTitle: this.$t('title'),
      metaDescription: this.$t('description'),
      metaKeywords: `${this.$t('title')},${this.$t('keywords')}`
    };
    return {
      title: fullSeo.metaTitle,
      meta: this.$options.filters.cmsMetaTags(fullSeo)
    }
  },
  jsonld() {
    const ret = []
    const breadcrumbs = this.getBreadcrumbsJsonld(this.breadcrumbs)
    breadcrumbs && ret.push(breadcrumbs)
    return ret
  }
}
</script>
